<ng-template #loading>
    <edp-loader [size]="'full'" [position]="'center'"></edp-loader>
</ng-template>
<div class="d-flex flex-column container-fluid vh-100 p-0"
    [ngStyle]="{'touch-action': (isApp && openedKeyboard) ? 'none' : 'auto'}"
    [ngClass]="{'opened-keyboard': openedKeyboard && isAppiOS}">
    <div class="flex-grow-0 p-3 d-flex justify-content-between">
        <span class="titleSendReading"
            [innerHTML]="'pt.edp.edponline.dashboard.widget.consumptions.support.send.reading' | translate"></span>
        <button class="btn btn-close p-0 position-relative" (click)="dismiss()">
            <i class="icon-edponline-Bop-071 color-brownish-grey"  aria-hidden="true"></i>
        </button>
    </div>
    <div *ngIf="meterInstructionsLoaded; else loading" class="flex-grow-1">
        <div *ngIf="meter === null" class="h-100 d-flex flex-column py-2 px-3 backChooseMeter">  
            <span class="mb-3 titleChooseMeter"
                [innerHTML]="'pt.edp.edponline.dashboard.widget.consumptions.support.select' | translate"></span>
            
            <div class="mb-auto mt-auto">
                <ngx-slick-carousel
                    #meterList
                    class="carousel"
                    #slickModal="slick-carousel"
                    [config]="slideConfig"
                    (afterChange)="afterChange($event)"
                    (beforeChange)="beforeChange($event)">
                    <div
                        ngxSlickItem
                        class="slide pt-2 pb-2"
                        *ngFor="let meter of allMeters; first as isFirst; index as i">
                        <div 
                            [ngClass] = "{'meter-item-selected': meter.selected}"
                            class="meter-item"
                            (click)="onHighligthMeter($event, meter, i)">
                            <div class="meter-item-content">
                                <img
                                    src="{{ meter.picture }}" 
                                    alt="{{ meter.type }}">
                                <span [innerHTML]="meter.modelDescription"></span>
                            </div>
                        </div>
                    </div>
                </ngx-slick-carousel>
            </div>

            <button
                (click)="onSelectMeter()" 
                [disabled]="highlightedMeterIndex === null"
                class="btn btn-primary w-75 mb-2">
                <span>{{'Selecionar' | translate }}</span>
            </button>
        </div>
        <div *ngIf="meter !== null" class="h-100 d-flex flex-column">
            <div class="py-2 px-3 backChooseMeter">  
                <div>
                    <span class="titleSupportStepsMeter mr-4" [innerHTML]="meter.shortModelDescription | truncate"></span>
                    <a 
                        *ngIf="canChange"
                        class="titleSupportStepsMeter"
                        (click)="onDeselectMeter()">
                        {{'pt.edp.edponline.dashboard.widget.consumptions.support.change' | translate | uppercase }}
                    </a>
                </div>
            </div>

            <div 
                #steps 
                class="flex-grow-1 d-flex flex-column align-content-center justify-content-center px-3 py-2 selected-meter-item-content">
            </div>
        
            <div class="card-body p-3 pb-5-sa backChooseMeterReadings">
                <edp-widget-consumptions-electricity
                    [contract]="contract"
                    [activeMeters]="activeMetersElectricity"
                    (focusEmit)="focusMeter($event)"
                    (blurEmit)="blurMeter()"
                    (submitted)="onSubmitted($event)">
                </edp-widget-consumptions-electricity>
            </div>
        </div>
    </div>
</div>